import React, {FC} from "react"

import {H6, Label} from "@irati/ui/src/Typography"
import Flex from "@irati/ui/src/Flex"
import authentication from "@irati/auth"
import {FormattedMessage} from "@irati/utils/lang"
import {UserRedemptionReportSavings} from "@irati/types"

import {DiscountIcon, GiftCardsIcon, FlexiPointsIcon} from "./Icons"

interface Props {
  savings: UserRedemptionReportSavings
}

const SaveWith: FC<Props> = ({savings}) => {
  const hasThisMonthSavings = savings.total.value > 0
  const hasFlexiPointsWallet = !!authentication.apps("wallet.treatTokens")

  if (hasThisMonthSavings) {
    return null
  }

  return (
    <Flex alignItems="center" gap={2}>
      {hasFlexiPointsWallet && (
        <Flex alignItems="center" gap={1}>
          <FlexiPointsIcon />
          <div>
            <H6 as="span">
              <FormattedMessage id="platform.mySavings.saveWith.save.copy" />
            </H6>
            <Label>
              <FormattedMessage id="platform.mySavings.saveWith.flexiPoints.copy" />
            </Label>
          </div>
        </Flex>
      )}
      <Flex alignItems="center" gap={1}>
        <GiftCardsIcon />
        <div>
          <H6 as="span">
            <FormattedMessage id="platform.mySavings.saveWith.save.copy" />
          </H6>
          <Label>
            <FormattedMessage id="platform.mySavings.saveWith.giftCards.copy" />
          </Label>
        </div>
      </Flex>
      <Flex alignItems="center" gap={1}>
        <DiscountIcon />
        <div>
          <H6 as="span">
            <FormattedMessage id="platform.mySavings.saveWith.save.copy" />
          </H6>
          <Label>
            <FormattedMessage id="platform.mySavings.saveWith.discounts.copy" />
          </Label>
        </div>
      </Flex>
    </Flex>
  )
}

export default SaveWith
